var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row bg-white footer"},[_c('div',{staticClass:"col-12 text-center my-3"},[_c('small',[_c('a',{attrs:{"href":"https://crisalidalabs.com/","target":"_blank"}},[_c('i',{staticClass:"far fa-copyright"}),_vm._v(" Crisálida Labs 2025")])])])])
}]

export { render, staticRenderFns }